import { CmProAuthService } from './../../../core/services/cmpro-auth.service';
import { Component } from "@angular/core";
import { NotificationService } from "@app/core/services/notification.service";
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: "sa-logout",
    template: `
        <div id="logout" class="btn-header">
            <button (click)="showPopup()" title="Sign Out"><i class="fas fa-sign-out"></i></button>
        </div>
    `,
    styles: []
})
export class LogoutComponent {

    constructor(
        private notificationService: NotificationService,
        private cmProAuthService: CmProAuthService,
        private router: Router
    ) {
    }

    showPopup() {
        this.notificationService.smartMessageBox(
            {
                title:
                    "<i class='fa fa-sign-out signoutLink'></i> Logout <span class='signoutLink'><strong>" + this.cmProAuthService.user.username + "</strong></span> ?",
                content:
                    "You can improve your security further after logging out by closing this opened browser",
                buttons: "[No][Yes]"
            },
            ButtonPressed => {
                if (ButtonPressed == "Yes") {
                    this.logout();
                }
            }
        );
    }

    logout() {
        this.cmProAuthService.logout(
            { postLogoutRedirectUri: environment.authConfig.configuration.postLogoutRedirectUri }
        );
    }
}
